import React from 'react';
import { LinearProgress } from '@material-ui/core';

import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles(({
  boxLoading : {
    backgroundColor : '#fff',
    boxShadow       : '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    marginTop       : 25,
    padding         : 24,
    '& h1'          : {
      marginTop : 0
    }
  },
}));

export default function PageLoading() {
  const classes = useStyle();

  return (
    <div className={classes.boxLoading}>
      <h1 align="center">Please wait, this might take a while.</h1>
      <LinearProgress variant="query" />
    </div>
  )
}